import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IWorkingSite } from '@interfaces/IWorkingSite';
import { siteService } from '@services/site.service';

export interface ISiteState {
  workingSite: IWorkingSite | null;
}

const initialState: ISiteState = {
  workingSite: siteService.getChosenSite(),
};

const siteSlice = createSlice({
  name: 'site',
  initialState,
  reducers: {
    setWorkingSiteSuccess(
      state,
      action: PayloadAction<{ workingSite: IWorkingSite }>,
    ) {
      state.workingSite = action.payload.workingSite;
      siteService.setChosenSite(action.payload.workingSite);
    },
    clearWorkingSite(state) {
      state.workingSite = null;
      siteService.removeChosenSite();
    },
  },
});

export const { setWorkingSiteSuccess, clearWorkingSite } = siteSlice.actions;
export const siteReducer = siteSlice.reducer;
